function a11y() {
	const self = this;

	self.audioPlayerFix = () => {
		const audioLink = document.querySelector(
			'.wp-block-embed__wrapper .wp-audio-shortcode .mejs-controls a.mejs-horizontal-volume-slider'
		);
		if (audioLink) {
	    audioLink.textContent = ' ';
			audioLink.setAttribute('aria-label', 'Listen to the audio clip');
		}
	}

	return self;
}

export default new a11y;
